import { ArrowRight, Phone } from "lucide-react";
import { business } from "../../config/site.config";

// SAB logo, tagline and actions brushed onto the empty wall at the end of the film (driven by HeroVideo).
export const WallEnding = ({ markRef, lineRef, callRef }) => (
  <div className="absolute inset-0 flex flex-col items-center justify-center pb-[12vh]">
    <img
      ref={markRef}
      src={`${process.env.PUBLIC_URL || ""}/brand/sab-logo.png`}
      alt="SAB Painting & Decorating"
      width="616"
      height="200"
      loading="lazy"
      className="w-[72vw] max-w-[560px] mix-blend-multiply md:w-[36vw]"
      style={{ opacity: 0, clipPath: "inset(-10% 100% -10% 0)" }}
      data-testid="hero-end-logo"
    />
    <p ref={lineRef} className="mt-5 text-center font-mono text-xs uppercase tracking-[0.24em] text-charcoal mix-blend-multiply sm:mt-7 sm:text-sm" style={{ opacity: 0 }} data-testid="hero-end-tagline">
      {business.heroTagline.split(" · ").map((part, i) => (
        <span key={part} className="block sm:inline">
          {i > 0 && <span className="hidden sm:inline" aria-hidden="true"> · </span>}
          {part}
        </span>
      ))}
    </p>
    <div ref={callRef} className="mt-7 flex flex-wrap items-center justify-center gap-3 px-5 sm:mt-9" style={{ opacity: 0, visibility: "hidden" }} data-testid="hero-end-actions">
      <a href={business.phoneHref} className="inline-flex h-11 items-center gap-2 bg-charcoal px-5 text-xs font-semibold uppercase tracking-[0.16em] text-beige transition-colors hover:bg-wildberry" data-testid="hero-end-call-button">
        <Phone className="h-4 w-4" aria-hidden="true" /> Call {business.phoneDisplay}
      </a>
      <a href="#estimate" className="inline-flex h-11 items-center gap-2 border border-charcoal/70 bg-beige/40 px-5 text-xs font-semibold uppercase tracking-[0.16em] text-charcoal backdrop-blur-sm transition-colors hover:border-wildberry hover:bg-wildberry hover:text-beige" data-testid="hero-end-estimate-link">
        Book an estimate <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </a>
    </div>
  </div>
);
